import { DEFAULT_DESCRIPTION, SITE_NAME } from "./constants.js";

export const pageMeta = {
    home: {
        title: `${SITE_NAME} — AI Quran App, Prayer Times & Islamic Companion`,
        description: DEFAULT_DESCRIPTION,
        path: "/",
    },
    news: {
        title: `Islamic & Muslim World News | ${SITE_NAME}`,
        description:
            "Curated Islamic and world news for Muslims — stay informed while learning Quran, prayer, and deen with Quran Chat Buddy.",
        path: "/news",
    },
    blogs: {
        title: `Islamic Blogs — Quran, Salah, Dua & Deen Guides | ${SITE_NAME}`,
        description:
            "Read clear Islamic guides on Allah, the Holy Quran, Prophet Muhammad ﷺ, how to pray Salah, dua, Ramadan, Tawhid, and how to become Muslim.",
        path: "/blogs",
    },
    quranPdf: {
        title: `Quran PDF Download Free (Arabic & English) | ${SITE_NAME}`,
        description:
            "Free Holy Quran PDF download in Arabic and English. Offline Quran reading for Muslims — mobile, tablet, or desktop. Start your Quran journey today.",
        path: "/quran-pdf-download",
    },
    surahYaseen: {
        title: `Surah Yaseen (Yasin) PDF Download Arabic & English | ${SITE_NAME}`,
        description:
            "Download Surah Yaseen PDF free in Arabic and English translation. Read Surah Yasin offline — benefits, meaning, and recitation for Muslims.",
        path: "/surah-yaseen",
    },
    deenBuddy: {
        title: `AI Islamic App — Quran Chat, Prayer Times & Deen Growth | ${SITE_NAME}`,
        description:
            "Download Quran Chat Buddy: AI Quran assistant, accurate Salah prayer times, daily ayat, tafsir, Islamic learning, and tools to grow your deen.",
        path: "/deenbuddy",
    },
    terms: {
        title: `Terms of Service | ${SITE_NAME}`,
        description:
            "Read the Terms of Service for Quran Chat Buddy — rules and guidelines for using our Islamic companion app and website.",
        path: "/terms-of-service",
    },
    privacy: {
        title: `Privacy Policy | ${SITE_NAME}`,
        description:
            "Privacy Policy for Quran Chat Buddy — how we collect, use, and protect your data on iOS, Android, and the web.",
        path: "/privacy-policy",
    },
    dataDeletion: {
        title: `Data Deletion Request | ${SITE_NAME}`,
        description:
            "Request deletion of your Quran Chat Buddy app data on iOS and Android. Learn what we store and how to submit a request.",
        path: "/data-deletion",
    },
    contact: {
        title: `Contact Us — Support for Quran & Prayer App | ${SITE_NAME}`,
        description:
            "Contact Quran Chat Buddy for support, feedback, or questions about our AI Islamic companion, Quran learning, and prayer times app.",
        path: "/contact",
    },
    notFound: {
        title: `Page Not Found | ${SITE_NAME}`,
        description: "The page you requested could not be found.",
        path: "",
        noindex: true,
    },
};
